import { combineEpics } from 'redux-observable'
import { completeEpic, completeSuccessEpic } from 'components/features/future/epics/completeEpic'
import { partialCompleteEpic } from 'components/features/future/epics/partialCompleteEpic'

export const futureEpic = combineEpics(
  completeEpic,
  completeSuccessEpic,
  partialCompleteEpic,
)
